import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult, serializeQueryString} from '../../shared';

@Injectable({ providedIn: 'root' })
export class InvoicesService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'InvoicesService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  getList(route: string , uuid: string, filter: any): Observable<SendBackResult<ArrayResponse<any>>> {
    if (route === 'contracts') {
      // tslint:disable-next-line:no-any
      return this.get<ArrayResponse<any>>(`/contract/${uuid}/Invoices${serializeQueryString(filter)}`);
    }
    if (route === 'companies') {
      // tslint:disable-next-line:no-any
      return this.get<ArrayResponse<any>>(`/company/${uuid}/Invoices${serializeQueryString(filter)}`);
    }
    if (route === 'sites') {
      // tslint:disable-next-line:no-any
      return this.get<ArrayResponse<any>>(`/subscription/${uuid}/Invoices${serializeQueryString(filter)}`);
    }
  }
}
